const GUEST_CART_KEY = 'guestCart';
const API_URL = process.env.REACT_APP_API_URL;

const getStoredCart = () => {
  try {
    return JSON.parse(localStorage.getItem(GUEST_CART_KEY)) || { menuEntries: [], customItems: [] };
  } catch {
    return { menuEntries: [], customItems: [] };
  }
};

const saveCart = (cart) => {
  localStorage.setItem(GUEST_CART_KEY, JSON.stringify(cart));
  window.dispatchEvent(new Event('guestCartUpdated'));
  return cart;
};

const guestCartService = {
  async getCart() {
    return getStoredCart();
  },

  // menuItem must be the full menu item object (with ingredients, title, image, servings, _id)
  async addMenuToCart(menuItemId, selectedIngredients = [], preferredServings = null, includeSpices = false, includeOils = false, menuItem = null) {
    const cart = getStoredCart();
    const existing = cart.menuEntries.find(e => e.menuItemId === menuItemId);
    if (existing) {
      existing.count = (existing.count || 1) + 1;
      existing.selectedIngredients = selectedIngredients.length ? selectedIngredients : existing.selectedIngredients;
      existing.preferredServings = preferredServings ?? existing.preferredServings;
      existing.includeSpices = includeSpices;
      existing.includeOils = includeOils;
    } else {
      cart.menuEntries.push({
        menuItemId,
        menuItem,
        count: 1,
        selectedIngredients,
        preferredServings,
        includeSpices,
        includeOils,
        addedAt: new Date().toISOString()
      });
    }
    saveCart(cart);
    return { menuEntries: cart.menuEntries };
  },

  async removeFromCart(menuItemId) {
    const cart = getStoredCart();
    cart.menuEntries = cart.menuEntries.filter(e => e.menuItemId !== menuItemId);
    saveCart(cart);
    return { menuEntries: cart.menuEntries };
  },

  async updateCount(menuItemId, count) {
    const cart = getStoredCart();
    const entry = cart.menuEntries.find(e => e.menuItemId === menuItemId);
    if (entry) entry.count = count;
    saveCart(cart);
    return { menuEntries: cart.menuEntries };
  },

  async addCustomItem(name, quantity = '1', unit = '') {
    const cart = getStoredCart();
    const id = `guest_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;
    cart.customItems.push({ id, name, quantity, unit, addedAt: new Date().toISOString() });
    saveCart(cart);
    return { customItems: cart.customItems };
  },

  async updateCustomItem(itemId, updates) {
    const cart = getStoredCart();
    const item = cart.customItems.find(i => i.id === itemId);
    if (item) Object.assign(item, updates);
    saveCart(cart);
    return { customItems: cart.customItems };
  },

  async removeCustomItem(itemId) {
    const cart = getStoredCart();
    cart.customItems = cart.customItems.filter(i => i.id !== itemId);
    saveCart(cart);
    return { customItems: cart.customItems };
  },

  // Uses the public instacart endpoint (no auth required)
  async sendToInstacart(ingredients, recipeTitle = 'My Shopping List') {
    const baseUrl = API_URL.replace(/\/api$/, '');
    const response = await fetch(`${baseUrl}/api/instacart/shopping-list`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ingredients, recipeTitle })
    });
    if (!response.ok) throw new Error('Failed to create Instacart list');
    return response.json();
  },

  clearCart() {
    localStorage.removeItem(GUEST_CART_KEY);
    window.dispatchEvent(new Event('guestCartUpdated'));
  },

  getCartCount() {
    const cart = getStoredCart();
    return cart.menuEntries.length;
  }
};

export default guestCartService;
